/**
 * Formater le timestamp affiché (mm:ss)
 */
export function formatTimestamp(ts) {
  if (ts === null || ts === undefined) return '--:--';
  const minutes = Math.floor(ts / 60);
  const seconds = Math.floor(ts % 60);
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

/**
 * Convertir un hex en [r, g, b]
 */
export function hexToRgb(hex) {
  hex = hex.replace(/^#/, "");
  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('');
  }
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return [r, g, b];
}

/**
 * Calculer les dimensions du canvas selon le ratio
 */
export function calculateCanvasDimensions(windowSize, SIDEBAR_WIDTH, MIN_MARGIN, TOP_BAR_HEIGHT, BOTTOM_BAR_HEIGHT, CANVAS_RATIO) {
  const availableWidth = windowSize.width - SIDEBAR_WIDTH - 2 * MIN_MARGIN;
  const availableHeight = windowSize.height - 2 * MIN_MARGIN - TOP_BAR_HEIGHT - BOTTOM_BAR_HEIGHT;

  let canvasWidth = availableWidth;
  let canvasHeight = canvasWidth / CANVAS_RATIO;

  if (canvasHeight > availableHeight) {
    canvasHeight = availableHeight;
    canvasWidth = canvasHeight * CANVAS_RATIO;
  }

  const canvasPixelWidth = Math.round(canvasWidth);
  const canvasPixelHeight = Math.round(canvasHeight);
  const containerWidth = canvasWidth;
  const containerHeight = TOP_BAR_HEIGHT + canvasHeight + BOTTOM_BAR_HEIGHT;

  return {
    canvasWidth,
    canvasHeight,
    canvasPixelWidth,
    canvasPixelHeight,
    containerWidth,
    containerHeight,
  };
}
